import {FileTypeE, ScopeUploadFileE} from '@/features/chat/services/chat.http'
import {
    ACCEPTABLE_AUDIO_TYPES,
    ACCEPTABLE_IMAGE_TYPES,
    ACCEPTABLE_VIDEO_TYPES
} from '@/utilities/constants/fileUploader'
import {GeneralError, getErrorMessage} from '@/utilities/getAPIErrorMessage'
import axios, {AxiosRequestConfig} from 'axios'
import {uniqueId} from 'lodash'
import {useHandleError} from './useHandleError'
import {useSendMedia} from '@/features/chat/queries/useSendMedia'

export type scopeType =
    | ScopeUploadFileE.PHOTO
    | ScopeUploadFileE.VIDEO
    | ScopeUploadFileE.SURPRISE
    | ScopeUploadFileE.INDENTITY_DOCUMENT
    | ScopeUploadFileE.AUDIO
    | ScopeUploadFileE.GROUPS
    | ScopeUploadFileE.MEDIA_PACKAGE
    | ScopeUploadFileE.GOAL_MEDIA
    | ScopeUploadFileE.GOAL_PROOF

type UploadMediaProps = {
    scope: scopeType
    onSuccessPayload?: (pathLocation: string) => void
    onError?: (message: string) => void
}
type sendFileProps = {
    blob: Blob
    options?: AxiosRequestConfig
}

export const getTypeOfFile = (file: File): FileTypeE | undefined => {
    if (ACCEPTABLE_IMAGE_TYPES.includes(file.type) || file.type.startsWith('image')) return FileTypeE.PHOTO
    else if (ACCEPTABLE_VIDEO_TYPES.includes(file.type) || file.type.startsWith('video')) return FileTypeE.VIDEO
    else if (ACCEPTABLE_AUDIO_TYPES.includes(file.type) || file.type.startsWith('audio')) return FileTypeE.AUDIO
}

export const useUploadMedia = ({scope, onSuccessPayload, onError}: UploadMediaProps) => {
    const {mutateAsync: sendChatFile, isError, error} = useSendMedia()
    const uploadFile = async ({blob, options}: sendFileProps) => {
        const file = new File([blob], `${uniqueId('file')}.${blob.type.slice(blob.type.indexOf('/') + 1)}`, {
            type: blob.type,
            lastModified: new Date().getTime()
        })
        const fileType = getTypeOfFile(file)
        if (fileType) {
            try {
                const resPreLink = await sendChatFile({
                    fileName: file.name,
                    fileContentType: file.type,
                    fileType,
                    scope
                })
                const formData = new FormData()

                Object.entries(resPreLink.fields).forEach(([key, value]) => {
                    formData.append(key, value as string)
                })
                formData.append('file', file)
                await axios.post(resPreLink.url, formData, options)

                onSuccessPayload?.(resPreLink.url)
                return {url: resPreLink.url, fileUploadId: resPreLink.fileUploadId, type: fileType}
            } catch (error) {
                const message = getErrorMessage(error as GeneralError)
                onError?.(message)
            }
        }
        return {}
    }
    useHandleError({isError, error})
    return {uploadFile}
}
